var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "header fixed-top w-100" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center" },
      [
        _c(
          "div",
          { staticClass: "header__left" },
          [
            _c("router-link", { attrs: { to: "/" } }, [
              _c("img", {
                attrs: { src: require("@static/img/logo.svg"), alt: "" }
              })
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }